// src/app/solution/[id]/solution-context.js
'use client';
import { createContext, useContext } from "react";

const SolutionContext = createContext(null);

export function SolutionProvider({ value, children }) {
    return (
        <SolutionContext.Provider value={value}>
            {children}
        </SolutionContext.Provider>
    );
}

export function useSolution() {
    const ctx = useContext(SolutionContext);
    if (!ctx) throw new Error('useSolution must be used within a SolutionProvider');
    return ctx;
}
